/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * Button Service User Denied component
 *
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.11.0
 */

import { Button } from '../../../components/common';
import { IButtonProps } from '../../../components/common/Button/Button';
import ServiceUserDenied, { IServiceUserDenied } from './ServiceUserDenied';

const ButtonServiceUserDenied = (props: IButtonProps & Pick<IServiceUserDenied, 'tooltipMsg'>) => {
    const { children, tooltipMsg, ...buttonProps } = props;

    return (
        <ServiceUserDenied
            renderComponent={disabled =>
                <Button {...buttonProps} disabled={disabled || buttonProps.disabled}>{children}</Button>
            }
            tooltipMsg={tooltipMsg}
        />
    );
};

ButtonServiceUserDenied.defaultProps = {
    kind: 'mediumNormal',
    onClick: () => {
    },
};

export default ButtonServiceUserDenied;
